import { useEffect, useState } from "react";
import api from "@/lib/api";
import { logger } from "@/lib/logger";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export function Reviews({ product_id }) {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState({ rating: 5, title: "", body: "" });
  const [showForm, setShowForm] = useState(false);
  const { user } = useAuth();
  const refresh = () => api.get(`/reviews?product_id=${product_id}`).then(r => setReviews(r.data)).catch(e => logger.error(e));
  useEffect(() => { refresh(); }, [product_id]); // eslint-disable-line
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/reviews", { product_id, ...form, rating: Number(form.rating) }); toast.success("Review posted"); setShowForm(false); setForm({ rating: 5, title: "", body: "" }); refresh(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const avg = reviews.length ? (reviews.reduce((s,r) => s+r.rating, 0) / reviews.length).toFixed(1) : null;
  return (
    <section className="mt-16" data-testid="reviews-block">
      <div className="flex items-baseline justify-between">
        <div>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">Reviews</p>
          <h2 className="font-serif text-3xl mt-2">{reviews.length} review{reviews.length===1?"":"s"}{avg && <span className="text-[#C5A059] ml-3">★ {avg}</span>}</h2>
        </div>
        {user && <button onClick={() => setShowForm(!showForm)} data-testid="review-add-btn" className="text-xs font-mono tracking-widest uppercase border border-[#0a0a0a] px-4 py-2">{showForm ? "Cancel" : "Write Review"}</button>}
      </div>
      {showForm && (
        <form onSubmit={submit} className="mt-6 border border-[#E5E5E5] p-4 space-y-3">
          <div className="flex gap-1">{[1,2,3,4,5].map(n => <button key={n} type="button" onClick={() => setForm({...form, rating: n})} className={`text-2xl ${form.rating >= n ? "text-[#C5A059]" : "text-[#E5E5E5]"}`} data-testid={`review-star-${n}`}>★</button>)}</div>
          <input required placeholder="Title" value={form.title} onChange={e => setForm({...form, title: e.target.value})} data-testid="review-title" className="w-full border border-[#E5E5E5] px-3 py-2 text-sm"/>
          <textarea required rows={3} placeholder="Share your experience…" value={form.body} onChange={e => setForm({...form, body: e.target.value})} data-testid="review-body" className="w-full border border-[#E5E5E5] px-3 py-2 text-sm"/>
          <button data-testid="review-submit" className="bg-[#0a0a0a] text-white px-6 py-2 text-xs tracking-[0.25em] uppercase font-bold">Post Review</button>
        </form>
      )}
      <div className="mt-6 space-y-4">
        {reviews.map(r => (
          <div key={r.id} className="border border-[#E5E5E5] p-4" data-testid={`review-${r.id}`}>
            <div className="flex justify-between items-start">
              <p className="font-serif text-lg">{r.title}</p>
              <span className="text-[#C5A059]">{"★".repeat(r.rating)}<span className="text-[#E5E5E5]">{"★".repeat(5-r.rating)}</span></span>
            </div>
            <p className="text-xs font-mono text-[#888]">{r.author_name} · {new Date(r.created_at).toLocaleDateString()}</p>
            <p className="text-sm text-[#333] mt-2">{r.body}</p>
          </div>
        ))}
        {reviews.length === 0 && <p className="text-sm text-[#888]">No reviews yet. Be the first.</p>}
      </div>
    </section>
  );
}
